module.exports = __webpack_public_path__ + "img/rn.8739c86f.png";